import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import PageSelector from 'components/PageSelector';
import { getSearchPaging } from 'selectors';
import * as actions from 'actions';

export const SearchPageSelector = props => {
  const { query, queryString, ...otherProps } = props; //eslint-disable-line no-unused-vars
  return <PageSelector {...otherProps} />;
};

const mapStateToProps = (state, props) => {
  const { queryString } = props;
  return getSearchPaging(state, 'results', { queryString });
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onPrevClick: currentPage => {
      dispatch(actions.searchItemsFetch(currentPage - 1, props.query, props.queryString));
    },
    onNextClick: currentPage => {
      dispatch(actions.searchItemsFetch(currentPage + 1, props.query, props.queryString));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.searchUpdatePossiblePage(newPossiblePage, props.queryString));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.searchItemsFetch(newPage, props.query, props.queryString));
      }
    }
  };
};

SearchPageSelector.propTypes = {
  query: PropTypes.object,
  queryString: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Search/SearchPageSelector/index.js
 **/